import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const ServiceCard = ({ service, span = "" }) => {
  const { t } = useLang();
  return (
    <Link
      to={service.to}
      data-testid={`service-card-${service.slug}`}
      className={`group relative overflow-hidden rounded-3xl bg-white border border-[#E5E7EB] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-25px_rgba(8,33,51,0.18)] ${span}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={service.image}
          alt={t(`serviceData.${service.key}.title`)}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#082133]/40 via-transparent to-transparent" />
      </div>
      <div className="p-7 sm:p-8 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#111111] tracking-tight">
            {t(`serviceData.${service.key}.title`)}
          </h3>
          <p className="mt-2 text-[14px] text-[#4B5563] leading-relaxed">
            {t(`serviceData.${service.key}.tagline`)}
          </p>
        </div>
        <span className="flex-shrink-0 h-11 w-11 inline-flex items-center justify-center rounded-full bg-[#082133] text-[#FAFAFA] transition-transform group-hover:rotate-45">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </div>
    </Link>
  );
};

export default ServiceCard;
